module.exports = __webpack_public_path__ + "static/media/plate2-img2.865c8d33.png";